import React from 'react'

class FAQExpandingPanel extends React.Component {
  state = {
    expanded: false,
  };
  handleToggle = () => {
    this.setState({
      expanded: !this.state.expanded
    });
  };
  render() {
    return (
      <div className={`faq-expanding-panel ${this.state.expanded && 'expanded'}`}>
        <div className="faq-expanding-panel__flex">
          <div className="faq-expanding-panel__content">
            <h3 className="faq-expanding-panel__title" onClick={this.handleToggle}>{this.props.title}</h3>
            <div className="faq-expanding-panel__text">
              {this.props.children}
            </div>
          </div>
          <button
            className={`faq-expanding-panel__toggle ${this.state.expanded ? 'minus' : 'plus'}`}
            onClick={this.handleToggle}/>
        </div>
      </div>
    )
  }
}

export default FAQExpandingPanel;
